import { z } from 'zod';
import { userIdSchema } from './user-id.js';
// ---------------------------------------------------------------------------
// User roles
// ---------------------------------------------------------------------------
export const UserRoleSchema = z.enum(['user', 'moderator', 'admin']);
// ---------------------------------------------------------------------------
// User
// ---------------------------------------------------------------------------
export const UserSchema = z.object({
    id: userIdSchema,
    email: z.string().email(),
    name: z.string().min(1),
    avatar_url: z.string().url().nullable(),
    role: UserRoleSchema,
    created_at: z.string().datetime(),
});
//# sourceMappingURL=user.js.map